import axios from 'axios';
import { baseUrl_SPB } from '../../BaseUrl';

// Fetch all invoices
export const fetchInvoices = async (token) => {
	return axios.get(`${baseUrl_SPB}/api/v1/invorquote/getinvorquote?type=invoice`, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + token
		}
	});
};
